module.exports = __webpack_public_path__ + "static/5-459ed9f173925102f5bd83eb6b43c57f.jpg";